export default "__VITE_ASSET__Bks5fWKE__"